import { PackagingComponentDto } from '../../../data-transfer/entities/component-entities/packaging-component-dto';
import { Component, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogActions } from 'src/app/model/dictionary';
import { PackagingComponentsOverviewComponent } from '../../directory-tree/components/packaging-components-overview/packaging-components-overview.component';
import { PaginationDataSource } from 'src/app/util/pagination-datasource';
import { ComponentApiService } from 'src/app/data-transfer/services/component-api-service';

export const ADD_WITH_TRACKING = 'AddWithTracking';
export const ADD_WITHOUT_TRACKING = 'AddWithoutTracking';

@Component({
  selector: 'app-selection-dialog-components',
  templateUrl: './selection-dialog-components.component.html',
  styleUrls: ['./selection-dialog-components.component.scss']
})
export class SelectionDialogComponentsComponent {

  @ViewChild('packagingComponentsTable') packagingComponentsTable!: PackagingComponentsOverviewComponent;

  dataSource: PaginationDataSource<PackagingComponentDto>;
  displayedColumns: string[] = [];
  dialogTitle = '';
  componentCategoryId: number = 0;
  isDataExchangeSubRequest = false;

  constructor(
    protected dialogRef: MatDialogRef<SelectionDialogComponentsComponent>,
    componentApiService: ComponentApiService,
    @Inject(MAT_DIALOG_DATA) protected data: any
  ) {
    this.dataSource = new PaginationDataSource<PackagingComponentDto>(x => componentApiService.getComponentsByPage(x));
    if (data) {
      this.componentCategoryId = data.componentCategoryId;
      this.displayedColumns = data.displayedColumns;
      this.dialogTitle = data.dialogTitle;
      this.isDataExchangeSubRequest = data.isDataExchangeSubRequest;
    }
  }

  importComponents(withTracking: boolean) {
    /* let event: string;
    if (withTracking) {
      event = ADD_WITH_TRACKING;
      this.selectedComponents.forEach(x => {
        // Tracking input is ignored by backend, but needed to display tracking icon
        // x.hasInternalTracking = true;
        x.multiMaterial.hasInternalTracking = true;
      });
    } else {
      event = ADD_WITHOUT_TRACKING;
      this.selectedComponents.forEach(x => x.id = undefined);
    } */
    const event = withTracking ? ADD_WITH_TRACKING : ADD_WITHOUT_TRACKING;
    this.dialogRef.close({ event, data: this.packagingComponentsTable.selectedComponentIds });
  }

  closeDialog() {
    this.dialogRef.close({ event: DialogActions.REJECT });
  }
}
